export default function SkeletonCard() {
  return (
    <div className="flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200 animate-pulse">
      <div className="shrink-0 w-28 h-20 sm:w-40 sm:h-28 rounded-md bg-background-200" />
      <div className="flex-1 min-w-0">
        <div className="h-4 bg-background-200 rounded w-3/4 mb-3" />
        <div className="h-3 bg-background-200 rounded w-full mb-2" />
        <div className="h-3 bg-background-200 rounded w-5/6 mb-4" />
        <div className="h-3 bg-background-200 rounded w-1/3" />
      </div>
    </div>
  );
}